<section class="section section-article-banner">
    <div class="st-inner bgimg" [style.background-image]="'url(' + content.media_content + ')'">
        <div class="container"></div>
    </div>
</section>
